import { post } from 'lib/utils/axiosFetcher';

export const hcpRegistration = async (data: any) => {
  try {
    const response = await post('/HCP/AddHCPRegistration', { ...data });
    return response;
  } catch (_error) {}
};

export const callDapApiSendEmail = async (payload: any) => {
  try {
    await post('/Send/AddContactsToHCPMailingList', payload);
  } catch (_error) {}
};
